"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "dunning-letters",
    path: "/dunning-letters",
    component: "DunningLetters"
});
let DunningLetters = class DunningLetters extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('integro_api/list_dunning_letter');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    b_2248226175642056_contextMenu;
    dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns', 'b_2248226175642056_contextMenu'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "reference_number",
                        name: this.$fn.pgettext("DunningLetters", "Reference Number"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "dunningLetter",
                            params: {
                                id: "id",
                            },
                        },
                    },
                    {
                        field: "status",
                        name: this.$fn.pgettext("DunningLetters", "Status"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "gettext",
                                    context: "DunningLetterStatus",
                                    conversion: "StartCase",
                                },
                                {
                                    name: "badge",
                                    variantmap: {
                                        sent: "light",
                                        delivered: "success",
                                        error: "danger",
                                    },
                                    variantMapSource: "fieldValue",
                                },
                            ],
                        },
                    },
                    {
                        field: "company_name",
                        name: this.$fn.pgettext("DunningLetters", "Owner company"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "company_id",
                            },
                        },
                    },
                    {
                        field: "customer_name",
                        name: this.$fn.pgettext("DunningLetters", "Partner"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "client_id",
                            },
                        },
                    },
                    {
                        field: "customer_email",
                        name: this.$fn.pgettext("DunningLetters", "Client Email"),
                        formatter: {
                            name: "join",
                            separator: "; ",
                        },
                    },
                    {
                        field: "severity",
                        name: this.$fn.pgettext("DunningLetters", "Severity"),
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                    {
                        field: "created_by",
                        name: this.$fn.pgettext("DunningLetters", "Created by"),
                        formatter: {
                            name: "user",
                        },
                    },
                ],
                b_2248226175642056_contextMenu: {
                    items: [{
                            label: "Delete",
                            command: "remove",
                        },
                    ],
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("DunningLetters", "Dunning Letters"),
                icon: this.$config.dunningLetter.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7206_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_7208_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_reloadSlickgrid_7212_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async act_2248226175642056_request_7210_getActionArgs($event) {
        return {
            operation: "delete_dunning_letter",
            data: { id: $event.data.data.slug_id },
        };
    }
    async evh_2248226175642056_contextmenuRemove(event, scope) {
        return await this.actions.evh_2248226175642056_contextmenuRemove.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_showModal_7214_getActionArgs($event) {
        return {
            name: "SendMails",
            props: {
                items: this.selectedItems,
            },
        };
    }
    async evh_6466705138206980_click(event, scope) {
        return await this.actions.evh_6466705138206980_click.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_script_7218_getActionArgs_value($event) {
        this.$refs.grid.reload();
    }
    async act_8320016629450276_script_7218_getActionArgs($event) {
        return {
            value: () => this.act_8320016629450276_script_7218_getActionArgs_value($event),
        };
    }
    async act_8320016629450276_request_7216_getActionArgs($event) {
        return {
            operation: "bulk_delete_dunning_letter",
            data: this.selectedItems.map(p => ({ id: p.id, etag: null })),
        };
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7206 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7206_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7205 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7206,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7205],
        });
        const act_2248226175642056_setData_7208 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_7208_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_7207 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_7208,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_7207],
        });
        const act_2248226175642056_reloadSlickgrid_7212 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_2248226175642056_reloadSlickgrid_7212_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_success_7211 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_reloadSlickgrid_7212,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_2248226175642056_request_7210 = new core_1.actions.RequestAction({
            actionArgs: this.act_2248226175642056_request_7210_getActionArgs,
            events: [evh_2248226175642056_success_7211],
        });
        const evh_2248226175642056_contextmenuRemove_7209 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_request_7210,
            event: "contextmenu:remove",
            displayName: "request",
        });
        const evh_2248226175642056_contextmenuRemove = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_contextmenuRemove_7209],
        });
        const act_6466705138206980_showModal_7214 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6466705138206980_showModal_7214_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_click_7213 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_showModal_7214,
            event: "click",
            displayName: "showModal",
        });
        const evh_6466705138206980_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_click_7213],
        });
        const act_8320016629450276_script_7218 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8320016629450276_script_7218_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_success_7217 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_script_7218,
            event: "success",
            displayName: "script",
        });
        const act_8320016629450276_request_7216 = new core_1.actions.RequestAction({
            actionArgs: this.act_8320016629450276_request_7216_getActionArgs,
            displayName: "deleteItems",
            events: [evh_8320016629450276_success_7217],
        });
        const evh_8320016629450276_click_7215 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_request_7216,
            event: "click",
            displayName: "deleteItems",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_7215],
        });
        return {
            act_7315092382398562_closeModal_7206,
            evh_7315092382398562_close_7205,
            evh_7315092382398562_close,
            act_2248226175642056_setData_7208,
            evh_2248226175642056_selectedRowsChanged_7207,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_reloadSlickgrid_7212,
            evh_2248226175642056_success_7211,
            act_2248226175642056_request_7210,
            evh_2248226175642056_contextmenuRemove_7209,
            evh_2248226175642056_contextmenuRemove,
            act_6466705138206980_showModal_7214,
            evh_6466705138206980_click_7213,
            evh_6466705138206980_click,
            act_8320016629450276_script_7218,
            evh_8320016629450276_success_7217,
            act_8320016629450276_request_7216,
            evh_8320016629450276_click_7215,
            evh_8320016629450276_click,
            deleteItems: act_8320016629450276_request_7216,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], DunningLetters.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DunningLetters.prototype, "onSize", null);
DunningLetters = __decorate([
    (0, vue_property_decorator_1.Component)()
], DunningLetters);
exports.default = DunningLetters;
vue_property_decorator_1.Vue.component("DunningLetters", DunningLetters);
